const tableCellVerification = {
  Typography: 'Deseja realmente deletar este item?',
  editSwitchYes: 'Sim',
  editSwitchNo: 'Não'
};

export default tableCellVerification;
